import * as React from 'react';
import { DateRangeCalendar } from '../DateRangeCalendar';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * We don't pass all the props down to `DateRangeCalendar`,
 * because otherwise some unwanted props would be passed to the HTML element.
 */
export const renderDateRangeViewCalendar = ({
  value,
  defaultValue,
  referenceDate,
  onChange,
  className,
  classes,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  shouldDisableDate,
  reduceAnimations,
  onMonthChange,
  rangePosition,
  defaultRangePosition,
  onRangePositionChange,
  calendars,
  currentMonthCalendarPosition,
  slots,
  slotProps,
  loading,
  renderLoading,
  disableHighlightToday,
  readOnly,
  disabled,
  showDaysOutsideCurrentMonth,
  dayOfWeekFormatter,
  disableAutoMonthSwitching,
  sx,
  autoFocus,
  fixedWeekNumber,
  disableDragEditing,
  displayWeekNumber,
  timezone,
  availableRangePositions,
  views,
  view,
  onViewChange
}) => /*#__PURE__*/_jsx(DateRangeCalendar, {
  value: value,
  defaultValue: defaultValue,
  referenceDate: referenceDate,
  onChange: onChange,
  className: className,
  classes: classes,
  disableFuture: disableFuture,
  disablePast: disablePast,
  minDate: minDate,
  maxDate: maxDate,
  shouldDisableDate: shouldDisableDate,
  reduceAnimations: reduceAnimations,
  onMonthChange: onMonthChange,
  rangePosition: rangePosition,
  defaultRangePosition: defaultRangePosition,
  onRangePositionChange: onRangePositionChange,
  calendars: calendars,
  currentMonthCalendarPosition: currentMonthCalendarPosition,
  slots: slots,
  slotProps: slotProps,
  loading: loading,
  renderLoading: renderLoading,
  disableHighlightToday: disableHighlightToday,
  readOnly: readOnly,
  disabled: disabled,
  showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
  dayOfWeekFormatter: dayOfWeekFormatter,
  disableAutoMonthSwitching: disableAutoMonthSwitching,
  sx: sx,
  autoFocus: autoFocus,
  fixedWeekNumber: fixedWeekNumber,
  disableDragEditing: disableDragEditing,
  displayWeekNumber: displayWeekNumber,
  timezone: timezone,
  availableRangePositions: availableRangePositions,
  view: view,
  views: views,
  onViewChange: onViewChange
});